<script lang="ts">
  import type { SharedOrder } from "@shared/types/Order";
  import Index from "@distributor/svelte/Orders/Index.svelte";
  import Breadcrumb from "@shared/svelte/Components/Breadcrumb.svelte";
  import { get as getStoreValue } from "svelte/store";
  import CurrentUserStore from "@shared/svelte/Stores/CurrentUserStore";
  import * as _ from "lodash";
  import { params, page } from "@roxi/routify";
  import moment from "moment";

  export let ordersRes: SharedOrder[];
  export let paginationLimit: number;
  export let paginationEntries: number;
  export let managed = [];
  export let load;

  let heading = "Orders";
  let orderState = $params.orderState;
  let repFilter = $params.repFilter;
  let orderPage = Number($params.orderPage || 1);
  let orderSearch = $params.orderSearch || "";
  let order = $params.order || "order_date";
  let direction = $params.direction || "DESC";
  let fromDate = $params.from_date;
  let toDate = $params.to_date;

  const refreshPage = function () {
    let paramsToSend = {
      orderPage: orderPage,
      orderState: orderState,
      orderSearch: orderSearch,
      order: order,
      direction: direction,
      repFilter: repFilter,
      from_date: null,
      to_date: null,
    };
    if (fromDate) {
      paramsToSend.from_date = new Date(fromDate).toISOString();
    }
    if (toDate) {
      paramsToSend.to_date = new Date(toDate).toISOString();
    }
    window["stateService"].go("layout.home", paramsToSend);
    load(paramsToSend);
  };

  const areAllDistributorsNonIntegrated = _.every(
    getStoreValue(CurrentUserStore)["distributors"],
    distributor => !distributor.integrated,
  );

  const orderStates = [
    { name: "All Statuses", value: "" },
    { name: areAllDistributorsNonIntegrated ? "Confirmed" : "Accepted", value: "accepted" },
    { name: "Open", value: "pending" },
    { name: "Rejected", value: "rejected" },
  ];

  let orders = _.map(ordersRes, function (order) {
    order.order_events = _.map(order.order_events, function (event) {
      if (event && event.created_at) {
        event.created_at = moment(event.created_at).fromNow();
      }
      return event;
    });
    if (order.state == "pending_rejection") {
      order.state = "rejected";
    }
    return order;
  });

  // redirect to order when clicked
  const viewOrder = function (orderId) {
    window["stateService"].go("layout.order_info", { order_id: orderId });
  };

  const manager = function () {
    return ((window["$rootScope"].user.distributors || [])[0] || {}).role == "manager";
  };

  let ordersPagination = {
    perPage: paginationLimit,
    page: orderPage,
    totalEntries: paginationEntries,
    goToPage: function (n) {
      orderPage = n;
      refreshPage();
    },
  };

  const runSortAndFilter = function (attrs) {
    orderState = attrs.orderState;
    repFilter = attrs.repFilter;
    orderSearch = attrs.orderSearch || "";
    order = attrs.order || "order_date";
    direction = attrs.direction || "DESC";
    fromDate = attrs.fromDate;
    toDate = attrs.toDate;
    orderPage = 1;
    ordersPagination.page = orderPage;

    refreshPage();
  };

  const sortCallBack = function (sort) {
    runSortAndFilter({
      order: sort.order,
      direction: sort.direction,
    });
  };

  const callbacks = {
    viewOrder: viewOrder,
    isManager: manager,
    runSortAndFilter: runSortAndFilter,
    sortCallBack: sortCallBack,
  };

  let managedChoices = [];
  const prepareManagedChoices = function () {
    managedChoices = [
      { label: "All Reps", value: undefined },
      { label: "Mine", value: "mine" },
    ];
    _.each(managed, function (m) {
      managedChoices.push({ label: m.names[0], value: m.ids[0] });
    });
  };
  prepareManagedChoices();
</script>

<Breadcrumb {heading} {callbacks} />
{#if ordersPagination}
  <Index
    bind:orders
    bind:orderState
    bind:fromDate
    bind:toDate
    bind:orderSearch
    bind:repFilter
    bind:ordersPagination
    {orderStates}
    {managedChoices}
    {callbacks}
    bind:direction
    bind:order
  />
{/if}
